import { useNavigate } from 'react-router-dom';
import { Button, IconArrowLeft } from 'src/viewLayer/components/DesignSystem';

export const BackButton = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Button
      color="tertiary"
      data-testid="back-button"
      icon={<IconArrowLeft />}
      onClick={(): void => navigate(-1)}
      title="back-button"
    />
  );
};
